import ActivityList from '../../components/crm/ActivityList';

// Flat /crm/activities log page. ActivityList does the heavy lifting; this page
// just renders it unscoped so it shows everything in the account.
export const Activities = () => (
  <div className="space-y-6">
    <div>
      <h1 className="text-2xl font-bold text-gray-900">Activity log</h1>
      <p className="text-sm text-gray-600 mt-1">All logged activity across your operators and opportunities.</p>
    </div>

    <ActivityList />
  </div>
);

export default Activities;
